import { render, staticRenderFns } from "./featured-parent-section.vue?vue&type=template&id=c0b4fed0"
import script from "./featured-parent-section.vue?vue&type=script&lang=js"
export * from "./featured-parent-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports